import { token } from '@zillow/constellation';
import styled, { keyframes, css } from 'styled-components';
import { ZILLOW_NAVBAR_HEADER_HEIGHT_IN_PX } from '../../../../../../ZillowNavbarHeader';

const FadeIn = keyframes`
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
`;

export const MINIMUM_WIDTH_OF_DROPDOWN_IN_PX = 298;
type ZillowNavbarSectionMegaMenuContainerProps = {
    isVertical: boolean;
    isLeftAligned: boolean;
};
export const ZillowNavbarSectionMegaMenuContainer = styled.div<ZillowNavbarSectionMegaMenuContainerProps>`
    ${({ isVertical, isLeftAligned }) =>
        isVertical
            ? css`
                  min-width: ${MINIMUM_WIDTH_OF_DROPDOWN_IN_PX}px;
                  border: 1px solid ${token('colors.borderLight')};
                  // to avoid a double border, hide this border under the other.
                  margin-top: -1px;
                  ${isLeftAligned
                      ? css`
                            left: 0;
                        `
                      : css`
                            right: 0;
                        `}
              `
            : css`
                  left: 0;
                  width: 100%;
              `}
    position: absolute;
    z-index: 1000;
    display: flex;
    top: ${ZILLOW_NAVBAR_HEADER_HEIGHT_IN_PX.DESKTOP}px;
    opacity: 0;
    animation: ${FadeIn};
    animation-duration: 0.1s;
    animation-fill-mode: forwards;
    background-color: white;
    border-bottom: 1px solid ${token('colors.borderLight')};
`;
